export const DEFAULT_REFRESH_URL_BLACKLIST = [
  'login',
  'auth/register',
  'auth/password-reset/request',
  'auth/password-reset/context',
  'auth/password-reset/resend-activation',
  'auth/activation/validate',
  'auth/activation/complete',
  'token/refreshToken',
  'token/validateToken',
  'auth/reauth'];
